import { all } from 'redux-saga/effects'
import LayoutSaga from './layout/saga';
import devicesSaga from './DevicesPaymentStore/devicesSaga'
import lifeTimeSaga from './LifetimeSubscriber/lifeTimeSaga'
import getInTouchSaga from './GetInTouch/getInTouchSaga.js'
import getUninstallSaga from './UnistallSurvey/uninstallSaga.js'
import paymentIssuesSaga from './PaymentIssues/paymentIssuesSaga.js'
import betaEmailSaga from './iOS/iOSBetaEmails/betaEmailSaga.js'
import missingAppSaga from './iOS/iOSmissingApp/missingAppSaga.js'
import { watchWebVisitorsSaga, watchDeviceCountsSaga, watchBetaAnalyticsSaga, watchApplicationInstallationSaga, webWeeklyInsightSaga, watchAndroidUsersAnalytics, watchRecentActiveDevices, watchNewBetaJoiner } from './Dashboard/dashboardSaga.js'

export default function* rootSaga() {
    yield all([
        LayoutSaga(),
        devicesSaga(),
        lifeTimeSaga(),
        getInTouchSaga(),
        getUninstallSaga(),
        paymentIssuesSaga(),
        betaEmailSaga(),
        missingAppSaga(),
        watchWebVisitorsSaga(),
        watchDeviceCountsSaga(),
        watchBetaAnalyticsSaga(),
        watchApplicationInstallationSaga(),
        webWeeklyInsightSaga(),
        watchAndroidUsersAnalytics(),
        watchRecentActiveDevices(),
        watchNewBetaJoiner()
    ])
}